import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="fixed inset-0 z-[9999] bg-black flex flex-col items-center justify-center text-white p-6 text-center">
          <div className="text-4xl mb-3">⚠️</div>
          <div className="text-lg font-black mb-1">Something went wrong</div>
          <div className="text-sm text-slate-400 mb-4">Please reload the page and try again.</div>
          <button
            onClick={this.handleReload}
            className="px-4 py-2 rounded-lg bg-gradient-to-r from-fuchsia-500 to-rose-500 text-white text-sm font-black"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
